import { createContext } from 'react';
import { ErrorFallbackProps } from '../model/ErrorBoundaryModel';

export const ErrorBoundaryContext = createContext<ErrorFallbackProps>({
    error: null,
    onReset: () => {},
});

type ErrorBoundaryProviderProps = {
    contextValue: {
        error: Error | null;
        onReset: () => void;
    };
};

export const ErrorBoundaryProvider = ({
    children,
    contextValue,
}: React.PropsWithChildren<ErrorBoundaryProviderProps>) => {
    return (
        <ErrorBoundaryContext.Provider value={contextValue}>
            {children}
        </ErrorBoundaryContext.Provider>
    );
};
